import React from 'react';
import './ChatOverlay.css';

function ChatOverlay({ children }) {
  return <div className="chat-overlay">{children}</div>;
}

export default ChatOverlay;
